// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__owaqK","label":"Category_label__2xm_m","content":"Category_content__u3LWf","header":"Category_header__3js2L","location":"Category_location__2-KyU"};